/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Small library to add a toBoolean() method to underscore
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*global define */
define(
	'underscoreToBoolean',[
		'underscore'
	],
	function (_) {
		'use strict';

		_.mixin({
			/**
			 * Converts value to a boolean.
			 * Returns true if value is true, 'true', non-zero number or a non-empty object or non-empty array. Returns false otherwise.
			 * @param {mixed} value
			 * @return {boolean}
			 */
			toBoolean: function (value) {
				var valueType = typeof(value);

				if (valueType === 'boolean') {
					return value;
				}

				if (valueType === 'number') {
					return !!value;
				}

				return ((value + '').toLocaleLowerCase() === 'true') || (valueType === 'object' && !_.isEmpty(value));
			}
		});
		return _;
	}
);
